export const THREAD_PIN_PREFERENCES_STORAGE_KEY = 'askrichard.thread-pin-preferences';
export const THREAD_PINS_CHANGED_EVENT = 'askrichard:thread-pins-changed';

export type ThreadPinPreferences = Record<string, boolean>;

/** A personal rail preference stays useful even when a session source has no pin endpoint. */
export function readThreadPinPreferences(): ThreadPinPreferences {
  if (typeof window === 'undefined') return {};

  try {
    const value = window.localStorage.getItem(THREAD_PIN_PREFERENCES_STORAGE_KEY);
    const parsed: unknown = value ? JSON.parse(value) : {};
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return Object.fromEntries(
      Object.entries(parsed).filter((entry): entry is [string, boolean] => typeof entry[1] === 'boolean'),
    );
  } catch {
    return {};
  }
}

export function saveThreadPinPreferences(preferences: ThreadPinPreferences): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(THREAD_PIN_PREFERENCES_STORAGE_KEY, JSON.stringify(preferences));
    // Storage events reach other tabs; this makes a same-tab consumer that did
    // not make the change consistent too.
    window.dispatchEvent(new Event(THREAD_PINS_CHANGED_EVENT));
  } catch {
    // A personal shortcut must not stop the workspace rendering when storage is unavailable.
  }
}
